import React, { Component } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { getCurrentUserInfo, isRoleTypeAdmin, isRoleTypeOperator, isRoleTypeEmployee } from 'src/reducers/users/currentUser';
import Sidebar from 'jbc-front/components/Sidebar';
import { Dashboard, Employee, Setting, Procedure, Calculator, Kintai, Close, Hamburger, Adjustment } from 'jbc-front/components/icons';

import * as Urls from 'src/constants/EndpointUrls';
import onClickOutside from 'react-onclickoutside';
import Cookies from 'js-cookie';
import _ from 'lodash';

import styles from './SideMenu.scss';

const AdminSideMenu = ({ isOpen, offset }) => {
  const { t } = useTranslation();
  return (
    <Sidebar offset={offset} isOpen={isOpen}>
      <Sidebar.Item as="a" href={Urls.DASHBOARD_SHOW} icon={Dashboard}>
        {t('components.SideMenu.SideMenu.dashbord')}
      </Sidebar.Item>
      <Sidebar.Item as="a" href={Urls.EMPLOYEE_ATTENDANCE_LIST} icon={Kintai}>
        {t('components.SideMenu.SideMenu.attendance')}
      </Sidebar.Item>
      <Sidebar.Item as="a" href={Urls.EMPLOYEE_PAY_LIST} icon={Calculator}>
        {t('components.SideMenu.SideMenu.salary')}
      </Sidebar.Item>
      {/* <Sidebar.Item as="a" href={Urls.EMPLOYEE_BONUS_LIST} icon={Bonus}>
        {t('components.SideMenu.SideMenu.bonus')}
      </Sidebar.Item> */}
      <Sidebar.Item as="a" href={Urls.EMPLOYEES_LIST} icon={Employee}>
        {t('components.SideMenu.SideMenu.staff_list')}
      </Sidebar.Item>
      <Sidebar.Item as="a" href={Urls.REPORT_INDEX} icon={Procedure}>
        {t('components.SideMenu.SideMenu.created_document')}
      </Sidebar.Item>
      <Sidebar.Item as="a" href={Urls.YEAR_END_REPORT_INDEX} icon={Adjustment}>
        {t('components.SideMenu.SideMenu.year_end_document')}
      </Sidebar.Item>
      {/* {!isFreePlan(planType) && (
        <Sidebar.Item as="a" href={Urls.YEAR_END_ADJ_START} target="_blank" icon={Adjustment}>
          {t('components.SideMenu.SideMenu.year_end_adjustment')}
        </Sidebar.Item>
      )} */}
      <Sidebar.Item as="a" href={Urls.CLIENT_SETTINGS} icon={Setting}>
        {t('components.SideMenu.SideMenu.setting')}
      </Sidebar.Item>
    </Sidebar>
  );
};

const OperatorSideMenu = ({ isOpen, offset }) => {
  const { t } = useTranslation();
  return (
    <Sidebar offset={offset} isOpen={isOpen}>
      <Sidebar.Item as="a" href={Urls.DASHBOARD_SHOW} icon={Dashboard}>
        {t('components.SideMenu.SideMenu.dashbord')}
      </Sidebar.Item>
      <Sidebar.Item as="a" href={Urls.EMPLOYEE_ATTENDANCE_LIST} icon={Kintai}>
        {t('components.SideMenu.SideMenu.attendance')}
      </Sidebar.Item>
      <Sidebar.Item as="a" href={Urls.EMPLOYEES_LIST} icon={Employee}>
        {t('components.SideMenu.SideMenu.staff_list')}
      </Sidebar.Item>
      <Sidebar.Item as="a" href={Urls.USER_REPORTS} icon={Procedure}>
        {t('components.SideMenu.SideMenu.created_document')}
      </Sidebar.Item>
      <Sidebar.Item as="a" href={Urls.CLIENT_SETTINGS} icon={Setting}>
        {t('components.SideMenu.SideMenu.setting')}
      </Sidebar.Item>
    </Sidebar>
  );
};

const EmployeeSideMenu = ({ isOpen, offset }) => {
  const { t } = useTranslation();
  return (
    <Sidebar offset={offset} isOpen={isOpen}>
      <Sidebar.Item as="a" href={Urls.DASHBOARD_SHOW} icon={Dashboard}>
        {t('components.SideMenu.SideMenu.dashbord')}
      </Sidebar.Item>
      <Sidebar.Item as="a" href={Urls.EMPLOYEE_MY_PAYSLIPS} icon={Calculator}>
        {t('components.SideMenu.SideMenu.salary')}
      </Sidebar.Item>
      {/* @TODO: Hide Year-end Document, will be developed for Vietnamese markets later */}
      {/* https://donuts-vn.atlassian.net/browse/JBC-120 */}
      {/* <Sidebar.Item as="a" href={Urls.USER_REPORTS} icon={Procedure}>
        {t('components.SideMenu.SideMenu.created_document')}
      </Sidebar.Item> */}
      <Sidebar.Item as="a" href={Urls.USER_PROFILE_EDIT} icon={Setting}>
        {t('components.SideMenu.SideMenu.setting')}
      </Sidebar.Item>
    </Sidebar>
  );
};

class _SideMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSidebarOpen: false
    };
  }

  handleClickOutside = () => {
    this.HideMenu();
  };

  handleTap = () => {
    this.setState({
      isSidebarOpen: !this.state.isSidebarOpen
    });
  };

  HideMenu = () => {
    this.setState({
      isSidebarOpen: false
    });
  };

  render() {
    const { currentUser, planType } = this.props;
    const offset = _.get(currentUser, 'email') && Cookies.get('using_jbc_payroll') ? 80 : 56;

    return (
      <div className={styles.container}>
        {isRoleTypeAdmin(currentUser.roleType) && (
          <AdminSideMenu isOpen={this.state.isSidebarOpen} offset={offset} adminFlg={isRoleTypeAdmin(currentUser.roleType)} planType={planType} />
        )}
        {isRoleTypeOperator(currentUser.roleType) && <OperatorSideMenu isOpen={this.state.isOpen} offset={offset} />}
        {isRoleTypeEmployee(currentUser.roleType) && <EmployeeSideMenu isOpen={this.state.isSidebarOpen} offset={offset} />}
        <div onClick={this.handleTap} className={styles.menuBtn} role="button" tabIndex="0">
          {this.state.isSidebarOpen ? <Close size={20} /> : <Hamburger size={20} />}
        </div>
      </div>
    );
  }
}

const SideMenu = onClickOutside(_SideMenu);

const mapStateToProps = state => ({
  currentUser: getCurrentUserInfo(state) || {},
  planType: _.get(state, 'currentClient.item.data.planType')
});

export default connect(mapStateToProps)(SideMenu);
